import {InjectionToken} from '@angular/core';
import {IdName} from '@domain/id-name';
import {MachineGroup} from '@domain/machine-group/machine-group';
import {MachineGroupOverviewList} from '@presentation/pages/machine-overview/sidebar/group-editor/machine-group-overview-list';
import {Observable} from 'rxjs';
import {UniqueIdentifierObjectRepository} from '../unique-identifier-object-repository';

export const MACHINE_GROUPS = new InjectionToken<MachineGroups>('MachineGroups');

export interface MachineGroups extends UniqueIdentifierObjectRepository {
  getRoot(): Observable<MachineGroupOverviewList>;
  getById(id: number): Observable<MachineGroupOverviewList>;
  save(machineGroup: MachineGroup, floorplan?: File): Observable<MachineGroupOverviewList>;
  update(id: number, machineGroup: MachineGroup, updateFloorplan: boolean, floorplan?: File): Observable<MachineGroup>;
  delete(id: number): Observable<void>;
  move(id: number, parentGroupId: number): Observable<void>;
  getFloorplan(floorplanId: number): Observable<Blob>;
  removeMachineFromGroup(id: number, machineId: number): Observable<void>;
  addMachineToGroup(id: number, machineId: number, oldMachineGroupId?: number): Observable<void>;
  getCompatible(plasticProductId?: number, machineId?: number, toolId?: number): Observable<IdName[]>;
}
